
(function () {
  function formatMoney(cents) {
    return `$${(cents / 100).toFixed(2)}`;
  }

  function initRechargeUnitPrice() {
   
    if (!window.ALL_PRODUCTS || !window.ALL_PRODUCTS.length) return;
    
    var variantToMainId = (function buildVariantMap() {
      var map = {};
      var all = Array.isArray(window.ALL_PRODUCTS) ? window.ALL_PRODUCTS : [];

      all.forEach(function (p) {
        if (!p || p.id == null) return;
        var mainId = p.id;
        var vars = Array.isArray(p.variants) ? p.variants : [];

        vars.forEach(function (v) {
          if (!v || v.id == null) return;
          map[String(v.id)] = mainId;
        });
      });

      return map;
    })();
 
    $('.rb-addon-item').each(function () {
      var $item = $(this);
 
      $item.find('p').addClass('rb-price');
      $item.find('.rb-title').removeClass('rb-price');
 
      var $select = $item.find('select.rb-select.rb-variant-selector').first();
      if (!$select.length) return;

      var selectedVariantId = String($select.val() || '');
      var mainId = variantToMainId[selectedVariantId];
 
      var $tflex = $item.closest('.tflex');
 
      if (!$tflex.length) $tflex = $item.find('.tflex').first();

      if (!$tflex.length) return;

      if (mainId) {
        $tflex.attr('data-rb-item-id', String(mainId));
      } else { 
        $tflex.removeAttr('data-rb-item-id');   
      }
    
    });      

    $(document).on('change', 'select.rb-select.rb-variant-selector', function () {
      var $select = $(this);
      var selectedVariantId = String($select.val() || '');
      var mainId = variantToMainId[selectedVariantId];

      var $item = $select.closest('.rb-addon-item');
      var $tflex = $item.closest('.tflex');
      if (!$tflex.length) $tflex = $item.find('.tflex').first();
      if (!$tflex.length) $tflex = $select.closest('.tflex');

      if (!$tflex.length) return;

      if (mainId) {
        $tflex.attr('data-rb-item-id', String(mainId));
      } else {
        $tflex.removeAttr('data-rb-item-id');   
      }
    });  

    function normalizeTitle(str) {
      return (str || "")
        .replace(/\s+/g, " ")
        .trim()
        .toLowerCase();
    }

    // Map products by normalized title
    const productByTitle = new Map(
      (window.ALL_PRODUCTS || []).map(p => [normalizeTitle(p.title), p])
    );

    document.querySelectorAll('#recharge-bundles .rb-items-wrapper .tflex').forEach(rbItem => {
      
      const titleEl = rbItem.querySelector('.rb-title');
      if (!titleEl) return;
       
      const domTitle = normalizeTitle(titleEl.textContent);
      const product = productByTitle.get(domTitle);
      if (!product) return;
      console.log(domTitle)
      const variant = (product.variants || [])[0];
      if (!variant) return;

      const priceEl = rbItem.querySelector('.rb-price');
      if (!priceEl) return;
      console.log(variant)
      // Prevent double-binding
      if (rbItem.dataset.unitPriceBound === 'true') return;
      rbItem.dataset.unitPriceBound = 'true';

      if (!rbItem.querySelector('.recharge-unit-price')) {
        // Insert UI once
        priceEl.insertAdjacentHTML(
          'afterend',
          `<div class="recharge-unit-price product-item__price text-size--large" style="font-size:18px; color:#000000;margin-bottom:14px;">
            <div class="unit-price product-price--original"></div>
            <div class="package-price product-price--unit text-size--regular" style="display:block;padding-inline-start:0 !important;opacity:.62;font-size:80%;margin-top:-.125rem;margin-bottom:.125rem;"></div>
          </div>`
        );
      }

      // Hide original price block
      priceEl.style.display = 'none';

      const unitPriceEl = rbItem.querySelector('.unit-price');
      const packagePriceEl = rbItem.querySelector('.package-price');

      // Unit price
      if (variant.price_per_unit && variant.price_per_unit !== "null") {
        unitPriceEl.textContent = `$${Number(variant.price_per_unit).toFixed(2)} / lb`;
      } else {
        unitPriceEl.textContent = '';
      }

      // Package price
      packagePriceEl.textContent = `~ ${formatMoney(variant.price)} / package`;
    });

  }

  document.addEventListener('DOMContentLoaded', () => {
    initRechargeUnitPrice();

    const observer = new MutationObserver(initRechargeUnitPrice);
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
})();

 (function () {
  const moveCredits = () => {
    const creditWrapper = document.querySelector('.recharge-component-credit-balance')?.parentElement;
    if (!creditWrapper) return;

    creditWrapper.style.order = '-10';
  };

  const observer = new MutationObserver(() => {
    moveCredits();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  moveCredits();
})();
 
 
// (function () {
//   const isSubscriptionsPage = () =>
//     window.location.pathname.includes('/tools/recurring/portal') &&
//     window.location.pathname.includes('/overview');

//   if (!isSubscriptionsPage()) return;

//   const interval = setInterval(() => {
//     const rechargeHeader = document.querySelector('.main-header');
//     const pageContainer =
//       document.querySelector('[data-testid="page-container"]') ||
//       document.querySelector('#root');

//     if (!rechargeHeader || !pageContainer) return;

//     clearInterval(interval);

//     if (document.querySelector('.cloned-orders-header')) return;

//     const clonedHeader = rechargeHeader.cloneNode(true);
//     clonedHeader.classList.add('cloned-orders-header');

//     pageContainer.insertBefore(clonedHeader, pageContainer.firstChild);

//     rechargeHeader.remove();
//   }, 300);
// })(); 
